
import React, { FC, ReactNode } from 'react';
import { FaCopy } from 'react-icons/fa6';
import { Box, IconButton, Tooltip } from '@chakra-ui/react';

import { useAlert } from '../../hooks/use-alert';
import { Txt } from './text';

export type Variant =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'body1'
  | 'body2';

type FieldViewProps = {
  title: ReactNode;
  value?: string | number | ReactNode | null;
  color?: string;
  direction?: 'column' | 'row'; 
  ml?: number;
  captionVariant?: Variant;
  fullWidth?: boolean;
  canCopy?: boolean;
  noPB?: boolean;
  noWrap?: boolean;
};

export const FieldView: FC<FieldViewProps> = (props: FieldViewProps) => {
  const {
    title,
    fullWidth,
    value,
    direction,
    ml,
    captionVariant,
    color,
    canCopy,
    noPB,
  } = props;
  const { success } = useAlert();

  if (value === null || value === undefined || value === '') {
    return null;
  }

  const onCopyClick = () => {
    navigator.clipboard.writeText(value.toString()).then(() => {
      success('Значение скопировано');
    });
  };

  return (
    <Box
      display="flex"
      flexDirection={direction || 'column'}
      pb={noPB ? 0 : 1}
      ml={ml || 0}
      alignItems="baseline"
      justifyContent={fullWidth ? 'space-between' : 'flex-start'}
    >
      <Box mr={1}>
        <Txt variant={captionVariant || 'caption'} color="gray.500">
          {title}
        </Txt>
      </Box>
      <Box display="flex" alignItems='baseline'>
        <Txt color={color} align={fullWidth ? 'right' : undefined}>{value}</Txt>
        {canCopy && (
          <Box ml={1} style={{ cursor: 'pointer', color: 'gray.500' }}>
            <Tooltip label='Копировать' placement='top' >
              <IconButton size='xs' icon={<FaCopy fontSize="xs" color="#66A2FF"/>} aria-label="copy" 
                onClick={onCopyClick}
              />
            </Tooltip>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default FieldView;
